import { IoIosSwap } from 'react-icons/io';
import { LuDollarSign } from 'react-icons/lu';
import { BsDownload } from 'react-icons/bs';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import { useSwap } from '@/contexts/SwapProvider';
import classNames from '@/lib/misc/classNames';
import useAppDetails from '@/hooks/utilities/useAppDetails';
interface Props {
  setSendModalOpen: (value: boolean) => void;
  setDepositModalOpen: (value: boolean) => void;
  setSwapModalOpen: (value: boolean) => void;
}
const MobileActions = (p: Props) => {
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP
  } = useSession();
  const {
    resetAssets
  } = useSwap();
  const {
    setDepositCurrencyOverride
  } = useAppDetails();
  return <div className='py-2 px-4 w-full flex mt-3 justify-between text-xs' data-sentry-component="MobileActions" data-sentry-source-file="MobileActions.tsx">
      <ActionItem icon={<LuDollarSign className='h-4 w-4' />} className={'w-2/4'} label='Withdraw' onClick={() => p.setSendModalOpen(true)} data-sentry-element="ActionItem" data-sentry-source-file="MobileActions.tsx" />

      <ActionItem icon={<BsDownload className='h-4 w-4' />} className={'w-2/4'} label='Deposit' onClick={() => {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.home.goToDeposit,
        category: CATEGORIES.home
      });
      setDepositCurrencyOverride(null);
      p.setDepositModalOpen(true);
    }} data-sentry-element="ActionItem" data-sentry-source-file="MobileActions.tsx" />
      <ActionItem icon={<IoIosSwap size={18} />} label='Swap' onClick={() => {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.home.goToTrade,
        category: CATEGORIES.home
      });
      resetAssets();
      p.setSwapModalOpen(true);
    }} data-sentry-element="ActionItem" data-sentry-source-file="MobileActions.tsx" />
    </div>;
};
const ActionItem = ({
  icon,
  label,
  onClick,
  className
}: {
  icon: any;
  label: string;
  onClick?: any;
  className?: string;
}) => {
  return <div className={classNames('flex flex-col items-center gap-1 w-2/4 mx-1', className)} onClick={() => {
    onClick();
  }} data-sentry-component="ActionItem" data-sentry-source-file="MobileActions.tsx">
      <div className='flex justify-center items-center bg-genius-blue text-genius-cream rounded-[20px] font-bold w-full p-4'>
        <div>{icon}</div>
      </div>
      <p className='text-genius-cream/80 mt-0.5 text-[12px]'>{label}</p>
    </div>;
};
export default MobileActions;